module.exports = __webpack_public_path__ + "img/Screenshot (27).446676d1.png";